module.exports = __webpack_public_path__ + "img/toubiao.fc49c532.jpg";